import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import AppStoreLink from './AppStoreLink';

/**
 * Pricing (handoff §6). Structure, type and the two-card treatment are the
 * handoff's; the numbers are the app's real tiers, read from
 * src/config/subscriptionTiers.js - Guest = 3 AI actions/month, Free = 7;
 * Pro = $2.99/month (250) or $24.99/year (500, a 30% saving). Saved
 * recipes are unlimited on EVERY tier by deliberate decision (the finite
 * numbers were never enforced by any code path), so storage is a Free-card
 * promise, not a Pro differentiator - Pro's are scans, cook mode, pairings
 * and the PDF/Excel export formats.
 */

const Tick = () => (
  <svg
    viewBox="0 0 512 512"
    width="18"
    height="18"
    fill="none"
    stroke="var(--accent)"
    strokeWidth="44"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M416 128L192 384l-96-96" />
  </svg>
);

const TickRow = ({ children }) => (
  <div className="tick-row">
    <Tick />
    <span className="body-copy">{children}</span>
  </div>
);

const Pricing = () => (
  <section id="pricing" className="section" aria-labelledby="pricing-headline">
    <div className="section-inner">
      <Reveal>
        <div className="eyebrow">Pricing</div>
        <h2 id="pricing-headline" className="h2 section-headline" style={{ maxWidth: '20ch' }}>
          Free to keep. Paid to scan more.
        </h2>
        <div className="pricing-grid">
          <div className="card price-card">
            <div className="h3">Free</div>
            <div className="price-line">
              <span className="mono price-num">$0</span>
              <span className="body-copy price-period">forever</span>
            </div>
            <div className="hair" />
            <div className="tick-list">
              <TickRow>7 AI actions a month with a free account - 3 before you sign in</TickRow>
              <TickRow>Unlimited saved recipes, yours to keep</TickRow>
              <TickRow>Shopping list, pantry and data export</TickRow>
            </div>
            <AppStoreLink withGlyph={false} className="cta-secondary">
              Download free
            </AppStoreLink>
          </div>

          <div className="card price-card pro">
            <div className="price-title-row">
              <div className="h3">Pro</div>
              <div className="save-badge">SAVE 30%</div>
            </div>
            <div className="price-line">
              <span className="mono price-num">$2.99</span>
              <span className="body-copy price-period">
                a month - or $24.99 a year. US prices; the App Store shows yours in your currency.
              </span>
            </div>
            <div className="hair" />
            <div className="tick-list">
              <TickRow>250 AI actions a month - 500 on the yearly plan</TickRow>
              <TickRow>Cook mode, timers and voice</TickRow>
              <TickRow>Drink and wine pairings</TickRow>
              <TickRow>PDF and Excel export</TickRow>
            </div>
            <AppStoreLink withGlyph={false}>Get Pro on the App Store</AppStoreLink>
          </div>
        </div>
        <p className="pricing-smallprint">
          Subscriptions are billed through the App Store and can be cancelled there anytime.{' '}
          <Link to="/terms-of-service">Terms of Service</Link> and{' '}
          <Link to="/privacy-policy">Privacy Policy</Link> are available before purchase and in the
          app's settings.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Pricing;
